import { IdentifyFactory } from '../../utils/IdentifyFactory';
import { GlobalImport } from '../../utils/GlobalImport';
const Blockly = GlobalImport.getBlockly();

export class BlocklySingletons {
  get IDConst(): string {
    return 'block';
  }

  get newIdNumber(): number {
    const id =
      Blockly.getMainWorkspace()
        .getAllBlocks()
        .filter((b) => {
          // console.log("new number ", b.type, b.getField("id"));
          return b.getField('id') ? true : false;
        }).length - 1;
    // console.log("id",id);
    return id;
  }

  get newID(): string {
    return this.IDConst + this.newIdNumber;
  }

  randomColour(): string {
    return IdentifyFactory.instance.randomColour();
  }

  domToBlock(dom: any, workspace: any) {
    return Blockly.Xml.domToBlock(dom, workspace);
  }
}
export const utils = new BlocklySingletons();
